export const EVENT = {
  // Window/Document events
  RESIZE: 'resize',
  POPSTATE: 'popstate',

  // Custom application events
  UPDATE_FORM_DATA: 'update-form-data',
  QUOTE_DATA_UPDATED: 'quote-data-updated',

  // Lighthouse component events
  LH_CLOSE: 'lh-close',
  LH_CHANGE: 'lh-change',

  // Mouse/Focus events
  MOUSEENTER: 'mouseenter',
  MOUSELEAVE: 'mouseleave',
  FOCUSIN: 'focusin',
  FOCUSOUT: 'focusout',
} as const

export type EVENT = (typeof EVENT)[keyof typeof EVENT]
